module.exports = __webpack_public_path__ + "static/media/airdale.89029c17.jpg";